const NOTIFICATION_FREE_ROUTES = [
  '/login',
  '/login1',
  '/login2',
  '/customer/motor-doc-upload',
  '/public-document-upload',
  '/dashboard/customer/motor-doc-upload',
  '/dashboard/approved/motor',
  '/dashboard/request-for-further-discount/fire-dwelling',
  '/dashboard/request-for-further-discount/motor',
  '/document/view',
  '/motor-payment-upload',
  '/payment-complete',
];

/** Public and authentication pages must never connect or present portal notifications. */
export function allowsPortalNotifications(pathname: string): boolean {
  return !NOTIFICATION_FREE_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`));
}
